<template>
  <div id="hours" class="flex items-center z4" :class="{ 'bg-red': !isOpen }">
    <div id="hours-top" class="relative flex justify-between py2 md-py3 px2 md-px4 z4">
      <div id="top-left" class="flex-grow" v-html="hours.currentDate"></div>
      <!-- <div id="top-right" class="flex-grow" v-text="hours.text"></div> -->
      <div id="top-right" class="flex-grow">Hours</div>
    </div>
    <div id="hours-content" class="center p4 mx-auto">
      <div v-html="hoursText"></div>
      <!-- Opening Soon -->
    </div>
    <div id="hours-bottom" class="flex justify-between py2 md-py3 px2 md-px4">
      <div id="bottom-left" class="flex-grow"><router-link to="/">Go Back</router-link></div>
      <div id="bottom-right" class="flex-grow" v-html="hours.currentTimeFormatted"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  name: 'Hours',

  data () {
    return {
      timeInterval: ''
    }
  },
  props: ['hours'],
  mounted () {
    this.loadHours()
  },
  computed: {
    ...mapState([
      'hoursText'
    ]),
    isOpen () {
      return this.hours.status === 'open'
    }
  },
  methods: {
    ...mapActions([
      'loadHours'
    ])
  }
}
</script>

<style>
  #hours {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--color-green);
    color: white;

    &.bg-red {
      background: var(--color-red);
    }

    #hours-top {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }

    #hours-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }

    #hours-content {
      line-height: 1.2;
    }
  }
</style>
